import React, { Fragment, useState, useEffect } from 'react';
import { wsFindBy, wsGetAll, wsCreate, wsUpdate } from 'services/WService.js';
import { AllowedGuard } from 'components/Tvendo/Common/UserAction';
import { ConstantPermissions } from 'contexts/useConstant';

// @material-ui/core components
import { makeStyles } from '@material-ui/core/styles';

// core components
import GridItem from 'components/Grid/GridItem.js';
import Button from 'components/CustomButtons/Button.js';
import Card from 'components/Card/Card.js';
import CardBody from 'components/Card/CardBody.js';
import CardIcon from 'components/Card/CardIcon.js';
import CardHeader from 'components/Card/CardHeader.js';

import styles from 'assets/jss/material-dashboard-pro-react/views/extendedTablesStyle.js';

// material-ui icons
import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import { Toasty, useToasty } from 'hooks/Toasty';

import ContactModal from './Modal/ContactModal';
import { WithApp } from 'contexts/appContext';
import Add from '@material-ui/icons/Add';
import { Close, ContactPhone } from '@material-ui/icons';
import { useModal } from 'hooks/useModal';
import { wsRemove } from 'services/WService';

const StyleTable = {
  table: {
    minWidth: 1700
  }
};

const useStyles = makeStyles(styles);
const useStyleTable = makeStyles(StyleTable);

export default WithApp(function Contact(props) {
  const classes = useStyles();
  const claseTable = useStyleTable();
  const { businessPartner, confirmDelete, showNotify, reload } = props;
  // const [notify, showNotify] = useToasty();
  const [model, setOpen] = useModal();

  const bPartner = props.businessPartner;
  const [contacts, setContacts] = useState([]);
  const [contactId, setContactId] = useState();

  const [showModal, setShowModal] = useState(false);

  async function ListContact() {
    let response = await wsFindBy(
      'base/business-partner-contact',
      'base_business_partner_id',
      bPartner.id
    );
    if (response.success) setContacts(response.data);
  }

  async function save(data) {
    let response = {};
    if (!!contactId) {
      response = await wsUpdate('base/business-partner-contact', contactId, data);
    } else {
      /* console.log(data); */
      data = { ...data, base_business_partner_id: bPartner.id };
      response = await wsCreate('base/business-partner-contact', data);
    }
    if (response.success) {
      showNotify(response.message);
      ListContact();
      setShowModal(false);
    } else {
      showNotify(response.message, 'error');
    }
  }

  async function remove(id) {
    let response = await wsRemove('base/business-partner-contact', id);
    if (response.success) {
      showNotify(response.message);
      ListContact();
    } else {
      showNotify(response.message, 'error');
    }
  }

  useEffect(() => {
    ListContact();
  }, []);

  return (
    <Fragment>
      {/* <Toasty action={notify} /> */}
      {model.open ? (
        <ContactModal 
          close={setShowModal}
          model={model}
          setOpen={setOpen}
          save={save}
          contactId={bPartner.id}
          showNotify={showNotify}
          reload={() => ListContact()}
        />
      ) : undefined}
      <GridItem xs={12}>
        <Card>
          <CardHeader icon>
            <AllowedGuard
              permission={ConstantPermissions.BASE_BUSINESS_PARTNERS_CONTACT_STORE}
              component={
                <CardIcon color="primary">
                  <ContactPhone style={{ color: 'white' }} />
                </CardIcon>
              }
            >
              <CardIcon
                color={props.themeContext.buttonColorSuccess}
                onClick={() => setOpen({})}
                pointer="true"
              >
                <Add />
              </CardIcon>
            </AllowedGuard>
            <h4 className={classes.cardIconTitle}>Contactos</h4>
          </CardHeader>
          <CardBody>
            <TableContainer component={Paper}>
              <Table className={claseTable.table}>
                <TableHead>
                  <TableRow>
                    <TableCell>#</TableCell>
                    <TableCell>ID contacto</TableCell>
                    <TableCell>Nombre 1</TableCell>
                    <TableCell>Nombre 2</TableCell>
                    <TableCell>Apellidos</TableCell>
                    <TableCell>Dirección</TableCell>
                    <TableCell>Zona</TableCell>
                    <TableCell>Teléfono</TableCell>
                    <TableCell>Celular</TableCell>
                    <TableCell>Correo</TableCell>
                    <TableCell>Notas</TableCell>
                    <TableCell>Fec. nacimiento</TableCell>
                    <TableCell>Ciudad natal</TableCell>
                    <TableCell>Género</TableCell>
                    <TableCell>Profesión</TableCell>
                    <TableCell align="right">Acciones</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {contacts.map((contact, i) => {
                    return (
                      <TableRow key={i}>
                        <TableCell>{i + 1}</TableCell>
                        <TableCell>{contact.Name}</TableCell>
                        <TableCell>{contact.FirstName}</TableCell>
                        <TableCell>{contact.MiddleName}</TableCell>
                        <TableCell>{contact.LastName}</TableCell>
                        <TableCell>{contact.Address}</TableCell>
                        <TableCell>{contact.zone_description}</TableCell>
                        <TableCell>{contact.Tel1}</TableCell>
                        <TableCell>{contact.Cellolar}</TableCell>
                        <TableCell>{contact.E_MailL}</TableCell>
                        <TableCell>{contact.Notes1}</TableCell>
                        <TableCell>{contact.BirthDate}</TableCell>
                        <TableCell>{contact.BirthCity}</TableCell>
                        <TableCell>{contact.Gender === 'F' ? 'Femenino' : contact.Gender === 'M' ? 'Masculino' : ''}</TableCell>
                        <TableCell>{contact.Profession}</TableCell>
                        <TableCell align="right">
                          <AllowedGuard
                            permission={ConstantPermissions.BASE_BUSINESS_PARTNERS_CONTACT_UPDATE}
                          >
                            <Button
                              justIcon
                              round
                              color={props.themeContext.buttonColorSuccess}
                              size="sm"
                              className={classes.marginRight}
                              onClick={() => setOpen(contact)}
                            >
                              <EditIcon className={classes.icons} />
                            </Button>
                          </AllowedGuard>
                          <AllowedGuard permission={ConstantPermissions.BASE_BUSINESS_PARTNERS_CONTACT_DELETED}>
                            <Button
                              justIcon
                              round
                              simple
                              onClick={() => {
                                confirmDelete(
                                  'base/business-partner-contact', contact.id, ListContact
                                );
                              }}
                              color={props.themeContext.buttonColorDanger}
                              className="remove"
                            >
                              <Close />
                            </Button>
                          </AllowedGuard>
                        </TableCell>
                      </TableRow>
                    );
                  })}
                </TableBody>
              </Table>
            </TableContainer>
          </CardBody>
        </Card>
      </GridItem>
    </Fragment>
  );
});
